/** @file tileZoomStep: the next whole zoom of the Tile canvas in or out (a wheel notch, = or -). */

/**
 * `zoom` plus or minus a whole step that grows with the zoom (1 below 16x, 2 below 32x, 4 above), clamped to 8..64,
 * so a notch changes the size by a similar share at every zoom.
 */
export function tileZoomStep(zoom: number, dir: 1 | -1): number {
  const at = dir > 0 ? zoom : zoom - 1;
  const step = at < 16 ? 1 : at < 32 ? 2 : 4;
  return Math.min(64, Math.max(8, Math.round(zoom) + dir * step));
}
